import { IAction } from '../../../__core/Interfaces/IAction';
import COURSE_ACTIONS from '../Actions/ActionTypes';
import { CoursesListResponse } from '../Types/CoursesListResponse';
import { coursesListInitState } from './CoursesInitState';

export const coursesListReducer = (
  state: CoursesListResponse = coursesListInitState,
  action: IAction<CoursesListResponse>
): CoursesListResponse => {
  switch (action.type) {
    case COURSE_ACTIONS.FETCH_COURSES_LIST:
      return { ...action.payload };

    default:
      return state;
  }
};
